module.exports = __webpack_public_path__ + "img/edit.4ff9c0cc.svg";